import React from 'react';
import iq from './style.module.css';
import { URL, buildCourseContactUrl, CtaPosition } from '@Pages/url';
import OperatorSVGIcon from '@Components/svg_icon/operator';
import PhoneSVGIcon from '@Components/svg_icon/phone';
import LineInquiry from '@Components/line_inquiry/view';

type InquiryProps = {
    courseId?: string;
    isSp?: boolean;
};

export const Inquiry = (props: InquiryProps) => {
    const contactUrl = props.courseId ? buildCourseContactUrl(props.courseId, CtaPosition.Middle) : URL.CONTACT;
    return (
        <div className={iq.inquiry}>
            <div className={iq.mask} />
            <p className={iq.inquiry_title}>
                <OperatorSVGIcon front_fill='#E1742D' />
                会員権のお問合せはこちら
            </p>
            <div className={iq.inquiry_left}>
                <p className={iq.inquiry_text}>電話でお問合せ</p>
                <a className={iq.inquiry_tel} href={'tel:0120-18-0072'}>
                    <PhoneSVGIcon />
                    0120-18-0072
                </a>
            </div>
            <div className={iq.border} />
            <div className={iq.inquiry_right}>
                <a className={iq.inquiry_button} href={contactUrl}>
                    WEBでお問合せ
                </a>
            </div>
            {props.isSp && (
                <div className={iq.line_inquiry}>
                    {' '}
                    <LineInquiry />
                </div>
            )}
        </div>
    );
};

export default Inquiry;
